import { useProfileCustomValues } from "PFApp/hooks/use_profile_custom_values";
import { TableColumn } from "PFCore/types";
import { useMemo } from "react";

import { ProfileInfoCell } from "./profile_info_cell";

export const useCellFactory = () => {
  const { getCustomValue } = useProfileCustomValues();

  const cellRenderers = useMemo(
    () => ({
      name: ({ getValue }) => getValue() && <ProfileInfoCell profile={getValue()} />,
      coreSkills: ({ getValue }) => getValue().statistics.topSkillsCount || "-",
      otherSkills: ({ getValue }) => {
        const { skillsCount, topSkillsCount } = getValue().statistics;
        return skillsCount - topSkillsCount || "-";
      },
      custom_field: ({ column, getValue }) => {
        const customValue = getCustomValue(getValue(), column.id);
        return (customValue && String(customValue.value)) || "-";
      }
    }),
    [getCustomValue]
  );

  const defaultRenderer = ({ getValue }) => getValue() && String(getValue());

  return (column: TableColumn) =>
    cellRenderers[column.name] || cellRenderers[column.type!] || defaultRenderer;
};
